import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "measurements-selector__message"
}
const _hoisted_2 = {
  key: 1,
  class: "measurements-selector__message"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-spinner2" }, null, -1)
const _hoisted_4 = {
  key: 2,
  class: "measurements-selector__message"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon-spinner2" }, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 5,
  class: "measurements-selector__message"
}

import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import isEmpty from "lodash/isEmpty";
import { onBeforeUnmount } from "vue";
import { toggleAddToCartButtonState } from "@/functions/dom";
import ShapeUpload from "./ShapeUpload.vue";

interface Props {
	primitives: {
		font: string|boolean;
	};
	hasFailedLoadingFont?: boolean;

	unit: string;
	onResize: ({ canPreview }) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapePreview',
  props: {
    primitives: {},
    hasFailedLoadingFont: { type: Boolean },
    unit: {},
    onResize: { type: Function }
  },
  setup(__props: any) {

const props = __props;
const store = useStore();

const previewContainer = ref<HTMLElement | null>(null);
const isDragging = ref(false);
const dragStart = ref({ x: null, y: null });

const hasValidatorErrors = computed(() => store.getters.hasValidatorErrors);
const previewModel = computed(() => store.getters.getPreviewModel);
const canPreview = computed(() => store.getters.isShapeComplete);
const shape = computed(() => store.getters.shape);
const isLoading = computed(() => {
	if(!store.getters.isShapeComplete) {
		return false;
	}
	const completeModel = store.getters.getExportableModel;

	return isEmpty(completeModel) || isEmpty(completeModel.models);
});
const fontIsLoading = computed(() => store.getters.fontIsLoading);
const translation = computed(() => store.getters.translation);
const isShapeComplete = computed(() => store.getters.isShapeComplete);
const transformContainerStyle = computed(() => {
	return {
		transform: `translate(${translation.value[ 0 ]}px, ${translation.value[ 1 ]}px)`,
	};
});
const zoom = computed(() => store.getters.zoom);
const rotation = computed(() => store.getters.rotation);
const previewTransformStyle = computed(() => {
	return {
		display: 'flex',
		transform: `rotate(${rotation.value}deg) scale(${zoom.value})`,
		transition: "transform 0.5s ease 0s",
		transformOrigin: "center",
	};
});

const resizeObserver = new ResizeObserver(() => {
	updatePreviewShapeDimensions();
});

watch(hasValidatorErrors, (hasErrors: boolean) => {
	toggleAddToCartButtonState(hasErrors);
});

watch(shape, async (newValue, oldValue) => {
	if (newValue !== oldValue) {
		updatePreviewShapeDimensions();
	}
}, { deep: true });

onMounted(() => {
	if (previewContainer.value) {
		resizeObserver.observe(previewContainer.value);
		updatePreviewShapeDimensions();
	}
	store.dispatch('loadConfiguration');
});

onBeforeUnmount(() => {
	resizeObserver.disconnect();
});

function updatePreviewShapeDimensions(): void {
	if (!previewContainer.value) return;

	store.commit("updatePreviewShapeDimensions", {
		width: previewContainer.value.offsetWidth,
		height: previewContainer.value.offsetHeight,
	});

	if (props.onResize) {
		props.onResize({ canPreview: canPreview.value });
	}
}

function mousedown( event: MouseEvent ):void {
	if (!canPreview.value) return;

	dragStart.value.x = event.screenX;
	dragStart.value.y = event.screenY;
	isDragging.value = true;
}

function mouseup(): void {
	isDragging.value = false;
}

function mousemove( event: MouseEvent ): void {
	if (!isDragging.value) return;

	const diffX = event.screenX - dragStart.value.x;
	const diffY = event.screenY - dragStart.value.y;

	store.commit('updateTranslation', [
		translation.value[0] + diffX,
		translation.value[1] + diffY,
	] );

	dragStart.value.x = event.screenX;
	dragStart.value.y = event.screenY;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "previewContainer",
    ref: previewContainer,
    class: "measurements-selector__sub-section measurements-selector__preview",
    style: _normalizeStyle({'cursor': isDragging.value ? 'grabbing' : 'grab'}),
    onMousedown: mousedown,
    onMouseup: mouseup,
    onMousemove: mousemove
  }, [
    (props.hasFailedLoadingFont === props.primitives.font)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$i18n.messages.failedLoadingFont), 1))
      : (fontIsLoading.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$i18n.messages.isLoadingFont), 1)
          ]))
        : (isLoading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$i18n.messages.isLoadingCalculations), 1)
            ]))
          : (isShapeComplete.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "measurements-selector__preview-inner-container",
                style: _normalizeStyle(transformContainerStyle.value)
              }, [
                _createElementVNode("div", {
                  style: _normalizeStyle(previewTransformStyle.value),
                  innerHTML: previewModel.value
                }, null, 12, _hoisted_6)
              ], 4))
            : (shape.value === 'dxf')
              ? (_openBlock(), _createBlock(ShapeUpload, {
                  key: 4,
                  isInPreview: true
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$i18n.messages.noPreview), 1))
  ], 36))
}
}

})